var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHardDriveBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8029 5.14364C18.7429 4.8223 18.5723 4.53207 18.3209 4.32321C18.0694 4.11435 17.7528 4.00001 17.4259 4H6.57387C6.24697 4.00001 5.93037 4.11435 5.67889 4.32321C5.42741 4.53207 5.2569 4.8223 5.19687 5.14364L3 16.8973H20.9998L18.8029 5.14364Z",
    fill: "#3E7EEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9395 15.8359H4.06047C3.47479 15.8359 3 16.3107 3 16.8964V19.5123C3 20.0979 3.47479 20.5727 4.06047 20.5727H19.9395C20.5252 20.5727 21 20.0979 21 19.5123V16.8964C21 16.3107 20.5252 15.8359 19.9395 15.8359Z",
    fill: "#3E7EEE",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9571 19.3008H8.04175C7.92986 19.3008 7.82255 19.2563 7.74344 19.1772C7.66432 19.0981 7.61987 18.9908 7.61987 18.8789C7.61987 18.767 7.66432 18.6597 7.74344 18.5806C7.82255 18.5015 7.92986 18.457 8.04175 18.457H15.9571C16.0689 18.457 16.1762 18.5015 16.2554 18.5806C16.3345 18.6597 16.3789 18.767 16.3789 18.8789C16.3789 18.9908 16.3345 19.0981 16.2554 19.1772C16.1762 19.2563 16.0689 19.3008 15.9571 19.3008Z",
    fill: "#FAFCFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.51956 17.8477H4.73608C4.62419 17.8477 4.51689 17.8032 4.43777 17.7241C4.35866 17.645 4.31421 17.5377 4.31421 17.4258C4.31421 17.3139 4.35866 17.2066 4.43777 17.1275C4.51689 17.0484 4.62419 17.0039 4.73608 17.0039H5.51956C5.63145 17.0039 5.73875 17.0484 5.81787 17.1275C5.89699 17.2066 5.94143 17.3139 5.94143 17.4258C5.94143 17.5377 5.89699 17.645 5.81787 17.7241C5.73875 17.8032 5.63145 17.8477 5.51956 17.8477Z",
    fill: "#F0A800"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.86893 17.8477H7.08545C6.97356 17.8477 6.86625 17.8032 6.78714 17.7241C6.70802 17.645 6.66357 17.5377 6.66357 17.4258C6.66357 17.3139 6.70802 17.2066 6.78714 17.1275C6.86625 17.0484 6.97356 17.0039 7.08545 17.0039H7.86893C7.98081 17.0039 8.08812 17.0484 8.16724 17.1275C8.24635 17.2066 8.2908 17.3139 8.2908 17.4258C8.2908 17.5377 8.24635 17.645 8.16724 17.7241C8.08812 17.8032 7.98081 17.8477 7.86893 17.8477Z",
    fill: "#F0A800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHardDriveBlue);
export default __webpack_public_path__ + "static/media/hard-drive-blue.9628bc804b17c0d89820dfb6536c2305.svg";
export { ForwardRef as ReactComponent };